module.exports = __webpack_public_path__ + "img/logo2.aa655040.png";